/* eslint-disable no-mixed-operators */
import { MAX_FILE_SIZE } from './constants';
import { ValidationErrors } from './enums';
export var parseFileSize = function parseFileSize(bytes) {
  var sizes = [' Bytes', 'KB', 'MB'];

  if (bytes === 0) {
    return '0 Bytes';
  }

  var index = Math.floor(Math.log(bytes) / Math.log(1024));
  return "".concat(Math.round(bytes / Math.pow(1024, index))).concat(sizes[index]);
};
/**
 * Check if given mime type is an image
 *
 * @param {String} mimeType
 */

export var isImage = function isImage(mimeType) {
  return mimeType.indexOf('image/') !== -1;
};
export var validateAttachment = function validateAttachment(_ref) {
  var type = _ref.type,
      name = _ref.name,
      size = _ref.size;
  var rules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _Object$assign = Object.assign({
    typeValidationPattern: new RegExp(/x-msdownload|vnd\.microsoft\.portable-executable|vnd\.android\.package-archive/),
    extensionValidationPattern: new RegExp(/.*(\.exe|\.apk)$/),
    maxFileSize: MAX_FILE_SIZE
  }, rules),
      typeValidationPattern = _Object$assign.typeValidationPattern,
      extensionValidationPattern = _Object$assign.extensionValidationPattern,
      maxFileSize = _Object$assign.maxFileSize;

  if (typeValidationPattern.test(type) || extensionValidationPattern.test(name)) {
    return ValidationErrors.FormatError;
  }

  if (size > maxFileSize) {
    return ValidationErrors.SizeError;
  }

  return null;
};